/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { classNames } from '@/utils/class-names';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/solid';

export default function Pagination({
  pageSize = null,
  currentPage,
  onChangePage,
}: {
  pageSize: number | null;
  currentPage: number;
  onChangePage: (page: number) => void;
}) {
  if (pageSize === null) {
    return null;
  }

  let initial: number, final, showInitialEllipsis, showFinalEllipsis, size;
  const isFinal = currentPage === pageSize;
  const isFirst = currentPage === 1;

  if (pageSize <= 6) {
    showInitialEllipsis = false;
    showFinalEllipsis = false;
    size = Array.from({ length: pageSize }, (_, i) => i + 1);
  } else {
    const offset = 3;
    initial = Math.max(1, currentPage - offset);
    final = Math.min(pageSize, currentPage + offset);
    showInitialEllipsis = currentPage > offset + 1;
    showFinalEllipsis = currentPage < pageSize - offset;

    size = Array.from({ length: final - initial + 1 }, (_, i) => initial + i);
  }

  const renderEllipsis = ({ onClick }: { onClick: () => void }) => {
    return (
      <span
        onClick={onClick}
        className="'inline-flex hover:text-gray-700' cursor-pointer items-center rounded-2xl px-4 py-[10px] text-sm font-medium text-gray-500">
        ...
      </span>
    );
  };

  return (
    <nav className="mt-sh-15 flex w-full items-center justify-center gap-4 ">
      {!isFirst && (
        <div className="flex">
          <a
            onClick={() => onChangePage(currentPage - 1)}
            className="inline-flex cursor-pointer items-center pr-1 text-sm font-medium text-gray-500 hover:text-gray-700">
            <ChevronLeftIcon className="mr-3 h-5 w-5 text-gray-400 hover:text-gray-700" aria-hidden="true" />
            Previous
          </a>
        </div>
      )}
      <div className="hidden gap-4 md:flex">
        {showInitialEllipsis && renderEllipsis({ onClick: () => onChangePage(1) })}
        {size.map((i) => {
          return (
            <a
              key={i}
              onClick={() => onChangePage(i)}
              className={classNames(
                'inline-flex cursor-pointer items-center rounded-2xl px-4 py-[10px] text-sm font-medium text-gray-500 hover:text-gray-700',
                i == currentPage ? 'border border-primary-500' : '',
              )}>
              {i}
            </a>
          );
        })}
      </div>
      {showFinalEllipsis && renderEllipsis({ onClick: () => onChangePage(pageSize) })}
      {!isFinal && (
        <div className="flex">
          <a
            onClick={() => onChangePage(currentPage + 1)}
            className="inline-flex cursor-pointer items-center pl-1 text-sm font-medium text-gray-500  hover:text-gray-700">
            Next
            <ChevronRightIcon
              className=" ml-3 h-5 w-5 font-bold text-gray-400 hover:text-gray-700"
              aria-hidden="true"
            />
          </a>
        </div>
      )}
    </nav>
  );
}
